import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue, useState } from "react";
import { isPageVisible } from "@lilib/utils";
import useEventListener from "./useEventListener";
function usePageVisible() {
  var _useState = useState(isPageVisible),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEventListener(function () {
    return document;
  }, "visibilitychange", function () {
    setVisible(isPageVisible());
  });
  useDebugValue(visible);
  return visible;
}
export default usePageVisible;